import type {
    CloverCredentials,
    CloverOAuthCredentialsPublic,
    CloverOAuthCredentialsSecret,
} from './clover-credential.types';
import { CloverThirdPartySystemId } from './clover-system-constants';

export const CloverCredentialResolutionOutcome = {
    RESOLVED: 'resolved',
    INVALID_CREDENTIALS: 'invalid_credentials',
} as const;

export type CloverCredentialResolutionOutcome =
    (typeof CloverCredentialResolutionOutcome)[keyof typeof CloverCredentialResolutionOutcome];

export interface CloverCredentialResolutionRequest {
    readonly systemId: typeof CloverThirdPartySystemId;
    readonly publicCredentials: CloverOAuthCredentialsPublic;
    readonly secretCredentials: CloverOAuthCredentialsSecret;
    readonly credentialUuid?: string;
}

export interface CloverCredentialResolutionNormalizedResult {
    readonly credentials: CloverCredentials;
    readonly merchantId: string;
}

export type CloverCredentialResolutionResponse =
    | {
          readonly outcome: typeof CloverCredentialResolutionOutcome.RESOLVED;
          readonly normalizedResult: CloverCredentialResolutionNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverCredentialResolutionOutcome.INVALID_CREDENTIALS;
          readonly message: string;
      };
